module.exports = __webpack_public_path__ + "static/media/30-10.5864135e.mp3";